import { CheckInSummaryState, checkInSummaryReducer } from './reducers/checkInSummarySlice';
import { NotificationState, notificationReducer } from './reducers/notificationSlice';
import { Reducer, combineReducers } from '@reduxjs/toolkit';
import { StoreInfoState, storeInfoReducer } from './reducers/storeInfoSlice';
import { VendorCheckInState, vendorCheckInReducer } from './reducers/vendorCheckInSlice';

export interface GlobalVendorCheckInState {
  vendorCheckIn: VendorCheckInState;
  storeInfo: StoreInfoState;
  checkInSummary: CheckInSummaryState;
  notifications: NotificationState;
}

export const globalVendorCheckInReducer: Reducer<GlobalVendorCheckInState> = combineReducers({
  vendorCheckIn: vendorCheckInReducer,
  storeInfo: storeInfoReducer,
  checkInSummary: checkInSummaryReducer,
  notifications: notificationReducer
});
